export default class PopoverController {
    /** @ngInject */
    constructor(AuthService, $state) {
        this.AuthService = AuthService;
        this.$state = $state;
    }

    $onInit() {
        const authData = this.AuthService.getAuthData();

        if (authData) {
            this.userProfile = authData.profile;
        }
    }

    signOut() {
        this.AuthService.signOut();
    }

    goToAccouunt() {
        this.$state.go('main.account-settings');
        this.onClose();
    }
}



// WEBPACK FOOTER //
// ./app/common/user-popover/user-popover.controller.js